interface SectionRenderStateInput {
  isLoading: boolean;
  isError: boolean;
  isStalled: boolean;
}

interface SectionRenderState {
  /**
   * Show the "AI is generating" treatment: badge, skeleton, dimmed content.
   *
   * False once a section is stalled. A stalled section is still
   * SECTION_PREDICTION_PENDING server-side — that is deliberate, it keeps the report poll
   * alive so a late-but-successful generation still lands — but the UI must stop implying
   * progress. (PROA-2110)
   */
  showLoading: boolean;
  /** Show the recovery panel offering Regenerate, for a failed or stalled section. */
  showRecovery: boolean;
}

export const getSectionRenderState = ({
  isLoading,
  isError,
  isStalled,
}: SectionRenderStateInput): SectionRenderState => ({
  showLoading: isLoading && !isStalled,
  showRecovery: isError || isStalled,
});

/** Border treatment for the section shell. Kept as an if-chain to avoid nested ternaries. */
export const sectionStateBorderClass = (showLoading: boolean, isStalled: boolean, isError: boolean): string => {
  if (showLoading) return "border-2 border-blurple-300 ";
  if (isStalled) return "border-2 border-amber-300";
  if (isError) return "border-2 border-red-300";
  return "";
};

/** Pointer/opacity treatment for the content block while generating. */
export const sectionContentBlockClass = (showLoading: boolean, hasFields: boolean | undefined): string => {
  if (!showLoading) return "";
  return hasFields ? "pointer-events-none opacity-20" : "pointer-events-none";
};
